import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useAppSelector } from '@/configureStore';
import { selectDisplayTax } from '@stores/preferences';

import type { AppRootState } from '@/configureStore';

export interface IPriceDisplaySimple {
  price: {
    exTax: {
      numeric: number;
    };
    incTax: {
      numeric: number;
    };
  };
  quantity?: number;
  className?: string;
  showTaxLabel?: boolean;
}

export const PriceDisplaySimple = ({ price, quantity = 1, className, showTaxLabel = true }: IPriceDisplaySimple) => {
  const { t, lang } = useTranslation('common');
  const displayTax: boolean = useAppSelector((state: AppRootState) => selectDisplayTax(state));
  const taxKey = displayTax ? 'incTax' : 'exTax';
  const priceString = new Intl.NumberFormat(lang, { style: 'currency', currency: 'EUR' }).format(quantity * price[taxKey].numeric);

  return (
    <div className={className}>
      <span className="fw-medium">{priceString}</span>
      {showTaxLabel && (
        <>
          <br />
          <span className="text-muted text-xs">{displayTax ? t('label.inc-tax') : t('label.ex-tax')}</span>
        </>
      )}
    </div>
  );
};
